<template>
    <div>
        <div class="main-right" id="main-right" :style="{height: (getWinHeight-60) + 'px'}">
             <div class="third-nav">
                 <div class="third-nav-t">退款记录</div>
             </div>
           
            <div class="main-content" id="main-content" :style="{height: (getWinHeight-120)+'px'}">
                <div class="main-feature">
                    <div class="main-inner">
                        <!-- 搜索条件 start -->
                        <el-form :inline="true" ref="postData" :model="postData" class="demo-form-inline">
                            <el-form-item label="日期">
                                <!--:default-time="['12:00:00']"-->
                                <el-date-picker @change="changeDate" v-model="postData.date" type="datetimerange"
                                                start-placeholder="开始日期"
                                                end-placeholder="结束日期" format="yyyy-MM-dd hh:mm:ss" :default-time="['12:00:00']">
                                </el-date-picker>
                            </el-form-item>
                            <!--<el-form-item label="门店名">
                                <el-select v-model="postData.mer_store_id" placeholder="门店名">
                                    <el-option v-for="item in shopList"
                                               :key="item.id"
                                               :label="item.value"
                                               :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>-->
                            <el-form-item label="门店名 / 退款操作人">
                                <el-cascader
                                        @change="choShop"
                                        separator=" "
                                        :options="shopList"
                                        :props="{ checkStrictly: true ,value: 'id',label:'value'}"
                                        clearable></el-cascader>
                            </el-form-item>
                            <el-form-item label="订单号">
                                <el-input v-model="postData.order_no" placeholder="请输入订单号" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="支付方式">
                                <el-select v-model="postData.pay_method" placeholder="支付方式" clearable>
                                    <el-option v-for="item in payWay"
                                               :key="item.value"
                                               :label="item.label"
                                               :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <!-- <el-form-item label="退款操作人">
                                 <el-select v-model="postData.mer_user_id" placeholder="退款操作人">
                                     <el-option v-for="item in cashierList"
                                                :key="item.id"
                                                :label="item.value"
                                                :value="item.id"></el-option>
                                 </el-select>
                             </el-form-item>-->
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit" size="small" v-loading="searchState">查询</el-button>
                            </el-form-item>
                        </el-form>
                        <!-- 搜索条件 end -->

                        <!-- 展示数据 start -->
                        <div class="home-figure show-data" style="margin: 0 0 20px">
                            <el-row :gutter="10">
                                <el-col :sm="4" v-for="(ele,i) in showList" :key="i">
                                    <div class="grid-content">
                                        <div class="home-figure-content">{{ele.label}}</div>
                                        <div class="home-figure-num">{{ele.num}}</div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <!-- 展示数据 end -->

                        <!-- 表格 start -->
                        <template>
                            <el-table ref="multipleTable" :data="tableData" style="width: 100%;min-width: 780px;"
                                      @selection-change="handleSelectionChange">
                                <el-table-column prop="refund_time" label="退款时间">
                                </el-table-column>
                                <el-table-column prop="order_no" label="订单号 / 退款单号" width="260">
                                    <template slot-scope="scope">
                                        <p>订单号:&nbsp;{{scope.row.order_no ? scope.row.order_no : '--'}}</p>
                                        <p>退款单号:&nbsp;{{scope.row.refund_no ? scope.row.refund_no : '--'}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="order_total_price" label="实收金额(元)">
                                </el-table-column>
                                <el-table-column prop="store_name" label="门店名 / 退款操作人">
                                    <template slot-scope="scope">
                                        <p>门店名: {{scope.row.store_name ? scope.row.store_name : '--'}}</p>
                                        <p>退款操作人: {{scope.row.mer_user_name ? scope.row.mer_user_name : '--'}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="refund_amount" label="退款金额(元)">
                                </el-table-column>
                                <el-table-column prop="pay_time" label="支付时间">
                                </el-table-column>
                                <el-table-column prop="pay_method" label="支付方式">
                                    <template slot-scope="scope">
                                        <p>{{ map[scope.row.pay_method]}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="status" label="状态" fixed="right">
                                    <template slot-scope="scope">
                                        <p>{{ mapStatus[scope.row.status]}}</p>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                        <!-- 表格 end -->

                        <template>
                            <div class="block" style="text-align: center;margin-top: 30px;">
                                <el-pagination @size-change="handleSizeChange"
                                               @current-change="jumpPagination"
                                               @prev-click="prevClick"
                                               @next-click="nextClick"
                                               :current-page="pagination.currentPage"
                                               :page-sizes="pagination.pageCount"
                                               :page-size="pagination.pageSize"
                                               layout="total, sizes, prev, pager, next, jumper"
                                               :total="pagination.total">
                                </el-pagination>
                            </div>
                        </template>

                    </div>
                </div>
                <common-footer></common-footer>
            </div>
        </div>
    </div>
</template>

<script>
    import CommonFooter from '../../components/CommonFooter.vue'
    export default {
        name: "RefundRecord",
        components: {
            CommonFooter
        },
        computed: {
            getWinHeight: function () {
                return this.$winHeight;
            }
        },
        data: function () {
            return {
                map: {1:'支付宝',2:'微信'},//支付方式
                mapStatus: {1:'成功',2:'退款中', 3:'退款失败'},//退款状态 1 成功 2 退款中 3退款失败
                searchState: false,
                date: new Date(),
                //页面所需
                "pagination": {
                    "total": 0,
                    "pageCount": [10,20,50,100],
                    "currentPage": 1,
                    "pageSize": 10,
                    "show": '1-5'
                },
                //接口参数
                "postData": {
                    "cursor": 1,//当前第几页-游标
                    "size": 10,//每页条数
                    "start_time": '',
                    "end_time": '',
                    "mer_store_id": '',
                    "order_no": '',
                    "mer_user_id": '',
                    "date": '',
                    "pay_method": '',//【1-支付宝，2-微信】
                },
                choShops: {},//选择的店铺
                choCashier: {},//选择的退款操作人
                showList: [
                    {
                        label: '退款笔数',
                        num: 0
                    },
                    {
                        label: '退款金额',
                        num: 0
                    }
                ],
                shopList: [],
                payWay: [
                    {
                        value: '1',
                        label: '支付宝'
                    },
                    {
                        value: '2',
                        label: '微信'
                    },
                ],
                cashierList: [],
                tableData: [],
            }
        },
        methods: {
            /**
             *  选择时间
             */
            changeDate(val) {
                console.log(val, this.postData.date);
                if(val){
                    let start = new Date(val[0]),end = new Date(val[1]);
                    console.log(start,end);
                    this.postData.start_time = start.valueOf();
                    this.postData.end_time = end.valueOf();
                    console.log()
                }else {
                    this.postData.start_time = this.postData.end_time = '';
                }
                console.log(this.postData)
            },
            /**
             * 分页跳转【当前页】
             */
            jumpPagination(val) {
                console.log(val);
                this.pagination.currentPage = this.postData.cursor = val;
                // this.postData.cursor = val;
                this.getData();
            },
            /**
             * 上一页
             */
            prevClick() {
                this.pagination.currentPage --;
                this.postData.cursor --;
                this.getData();
            },
            /**
             * 下一页
             */
            nextClick() {
                this.pagination.currentPage ++;
                this.postData.cursor ++;
                this.getData();
            },
            /**
             * 每页条数
             * @param val
             */
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.pagination.size = this.postData.size = val;
                this.getData();
            },
            /**
             * 获取门店list
             */
            getShopData() {
                //初始化列表
                this.$axios.post('/mer/order/choose/store').then(res => {
                    console.log(res);
                    if (res.data.code === this.$webConfig.httpSuccessStatus) {
                        this.shopList = res.data.data;
                        this.shopList.forEach((item,index)=>{
                            // this.shopList[index].cities = [] // 视图未更新
                            this.$set(this.shopList[index], 'children', []) // right
                        })
                    }else {
                        this.$message(res.data.message);
                    }
                })
                    .catch(() => {
                        this.$message('网络异常！');
                    });
            },
            /**
             *  选择门店
             */
            choShop(val){
                console.log(val);
                if(val.length==0){
                    this.postData.mer_store_id = '';
                    this.postData.mer_user_id = '';
                    console.log(this.postData);
                }else if(val.length==1){
                    this.postData.mer_store_id = val[0];
                    console.log(this.postData);
                }else  if(val.length==2){
                    this.postData.mer_user_id = val[1];
                    console.log(this.postData);
                }
                if(val!=[]){
                    let value = val[0];
                    this.$axios.post('/mer/order/choose/cashier', {
                        'store_id': value
                    }).then((res) => {
                        let children = res && res.data && res.data.data || [];
                        for(let i = 0; i < this.shopList.length; i++) {
                            if(this.shopList[i].id === value) {
                                this.$set(this.shopList[i], 'children', children);
                                break;
                            }
                        }
                    })
                }
                console.log(this.postData);
            },
            /**
             * 获取列表数据
             */
            getData() {
                console.log(this.postData);
                let api = '/mer/payRefundOfflineOrder/list/list';
                //初始化列表
                this.$axios.post(api, this.postData).then(res => {
                    console.log(res);
                    if (res.data.code === this.$webConfig.httpSuccessStatus) {
                        this.tableData = res.data.data.data;
                        console.log(this.tableData);
                        this.pagination.total = res.data.data.count;
                        this.pagination.currentPage = res.data.data.cursor;
                    }else {
                        this.$message(res.data.message);
                    }
                    this.searchState = false;
                })
                    .catch(() => {
                        this.searchState = false;
                    });
            },
            /**
             * 查询
             */
            onSubmit() {
                console.log('submit!');
                this.searchState = true;
                this.pagination.currentPage = this.postData.cursor = 1;
                this.getData();
                this.getTopData();
            },
            /**
             * 获取顶部数据
             */
            getTopData() {
                //初始化列表
                this.$axios.post('/mer/payRefundOfflineOrder/list/summarizing', this.postData).then(res => {
                    console.log(res);
                    if (res.data.code === this.$webConfig.httpSuccessStatus) {
                        this.showList[0].num = res.data.data.count;
                        this.showList[1].num = res.data.data.total_refund_amount;
                    } else {
                        this.$message(res.data.message);
                    }
                })
                    .catch(() => {

                    });
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
        },
        created(){

        },
        beforeMount() {
            // 获取列表数据
            this.getData();
            //    获取门店list
            this.getShopData();
            // 获取顶部数据
            this.getTopData();
        },
    }
</script>


<style scoped>
    .el-date-editor--datetimerange {
        width: 360px !important;
        margin-top: 4px;
    }
</style>
